import React, { useEffect, useState } from 'react';

import BottomSheet from '@bharatpe/bharat-ui/web/BottomSheet';
import { CheckCircle } from '@bharatpe/bharat-ui/web/Icons';
import Icon from '@bharatpe/bharat-ui/web/Icon';
import { Button, Typography } from '@bharatpe/bharat-ui';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

interface IProps {
	handleImportantCheckpointClose?: (...args: any[]) => void;
	handleImportantCheckpointContinueClick: (...args: any[]) => void;
}

const ImportantCheckpointModal: React.FC<IProps> = ({
	handleImportantCheckpointClose,
	handleImportantCheckpointContinueClick,
}) => {
	const [showModal, setShowModal] = useState(false);
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Clicks Continue',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'LinkUPI',
			Module: 'Continue',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'continue',
		});
		setShowModal(true);
	}, []);

	const onContinueClick = () => {
		logAnalyticsEvent({
			trigger_point: 'Important Checkpoint Modal',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'LinkUPI',
			Module: 'Page',
			Action: 'Viewed',
		});
		handleImportantCheckpointContinueClick();
	};
	return (
		<BottomSheet visible={showModal} heading={languageData.IMPORTANT_CHECKPOINTS} rounded>
			<div className="p4">
				<div className="flex flex-row mb4">
					<Icon icon={CheckCircle} className="logo-green mr2" />
					<Typography variant="Light300" className="grey" component="span">
						{languageData.ENTER_UPI_PIN_ONLY_ON_UPI_PIN_PAGE}
					</Typography>
				</div>
				<div className="flex flex-row mb4">
					<Icon icon={CheckCircle} className="logo-green mr2" />
					<Typography variant="Light300" className="grey" component="span">
						{languageData.ONLY_SENDING_MONEY_REQUIRES_UPI_PIN}
					</Typography>
				</div>
				<div className="flex flex-row mb4">
					<Icon icon={CheckCircle} className="logo-green mr2" />
					<Typography variant="Light300" className="grey" component="span">
						{
							languageData.AVOID_SHARING_FINANCIAL_INFORMATION_ON_SOCIAL_MEDIA_CONTACT_THE_SERVICE_PROVIDER_THROUGH_CORRECT_CHANNELS
						}
					</Typography>
				</div>
				<div className="flex flex-row mb4">
					<Icon icon={CheckCircle} className="logo-green mr2" />
					<Typography variant="Light300" className="grey" component="span">
						{languageData.DONT_SHARE_OTP_WITH_ANYMORE}
					</Typography>
				</div>
				<Button size="large" className="mt5 width-100" disabled={false} onClick={onContinueClick}>
					{languageData.CONTINUE}
				</Button>
			</div>
		</BottomSheet>
	);
};

export default ImportantCheckpointModal;
